import { AttachmentMetadata } from '@codey2/codey-api-types/models';
import { codeyApiClient } from './codeyApiClient';
import { usePrivateApi } from './usePrivateApi';
import { useCallback, useState } from 'react';

export function useAttachmentsApi() {
  const [isLoading, setIsLoading] = useState(false);
  const { doPost, doDelete } = usePrivateApi();

  const getAttachments = useCallback(async (exerciseId: number): Promise<AttachmentMetadata[]> => {
    try {
      setIsLoading(true);
      const result = await codeyApiClient.get<AttachmentMetadata[]>(`/exercises/public/${exerciseId}/attachments`);
      return result;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const uploadAttachment = useCallback(
    async (exerciseId: number, file: File): Promise<AttachmentMetadata> => {
      try {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        return await doPost<FormData, AttachmentMetadata>(`/exercises/${exerciseId}/attachments`, formData);
      } finally {
        setIsLoading(false);
      }
    },
    [doPost]
  );

  const deleteAttachment = useCallback(
    async (exerciseId: number, attachmentId: number): Promise<void> => {
      try {
        setIsLoading(true);
        await doDelete(`/exercises/${exerciseId}/attachments/${attachmentId}`);
      } finally {
        setIsLoading(false);
      }
    },
    [doDelete]
  );

  const downloadAttachment = useCallback((exerciseId: number, attachmentId: number): string => {
    return `${codeyApiClient.defaults.baseUrl}/exercises/public/${exerciseId}/attachments/${attachmentId}`;
  }, []);

  return {
    getAttachments,
    uploadAttachment,
    deleteAttachment,
    downloadAttachment,
    isLoading,
  };
}
